module.exports = __webpack_public_path__ + "media/images/brand/people01-f069913803a6305b46ba0a8277e40d13.png";